import { css, etiColors, mediaQueries } from '@eti/styles';
import { mediumSkeleton, skeletonClassStyle, smallSkeleton } from './TripDetailsBoundSkeleton';

const wrapperStyles = css`
  align-items: center;
  display: flex;
  flex-basis: 50%;
  justify-content: flex-start;
  padding: 0.625rem;

  @media ${mediaQueries.large.up} {
    padding: 1.25rem;
  }

  &:first-child {
    border-bottom: 1px dotted ${etiColors.grayScale[8]};

    @media ${mediaQueries.medium.up} {
      border-bottom: none;
      border-right: 1px dotted ${etiColors.grayScale[8]};
    }
  }

  [dir='rtl'] & {
    &:first-child {
      border: 0;
    }

    &:last-child {
      border-bottom: 1px dotted ${etiColors.grayScale[8]};

      @media ${mediaQueries.medium.up} {
        border-bottom: none;
        border-right: 1px dotted ${etiColors.grayScale[8]};
      }
    }
  }
`;

const iconStyles = css`
  border-radius: 50%;
  flex-shrink: 0;
  height: 24px;
  margin-right: auto;
  ${skeletonClassStyle};
  width: 24px;

  [dir='rtl'] & {
    margin-left: auto;
  }

  @media ${mediaQueries.large.up} {
    height: 32px;
    margin: 0;
    width: 32px;

    [dir='rtl'] & {
      margin-left: 0;
    }
  }
`;

const ticketNameStyles = css`
  display: none;
  margin: 0 auto 0 10px;
  ${smallSkeleton};
  ${skeletonClassStyle};
  width: 80px;

  [dir='rtl'] & {
    margin: 0 10px 0 auto;
  }

  @media ${mediaQueries.large.up} {
    display: block;
  }
`;

const priceAndInfoStyles = css`
  margin-right: 10px;
  ${mediumSkeleton};
  position: relative;
  width: 80px;

  [dir='rtl'] & {
    margin-left: 10px;
    margin-right: 0;
  }

  &::before {
    content: '';
    ${smallSkeleton};
    position: absolute;
    right: 0;
    top: -15px;
    width: 100px;

    [dir='rtl'] & {
      left: 0;
      right: auto;
    }
  }

  &::after {
    bottom: -15px;
    content: '';
    ${smallSkeleton};
    position: absolute;
    right: 0;
    width: 100px;

    [dir='rtl'] & {
      left: 0;
      right: auto;
    }
  }
`;

const buttonStyles = css`
  height: 44px;
  ${skeletonClassStyle};
  width: 7.5rem;

  @media ${mediaQueries.medium.up} {
    width: 8.75rem;
  }

  @media ${mediaQueries.large.up} {
    width: 10rem;
  }
`;

const TripTicketTypeSkeleton = () => (
  <div className={wrapperStyles}>
    <div className={iconStyles} />
    <div className={ticketNameStyles} />
    <div className={priceAndInfoStyles} />
    <div className={buttonStyles} />
  </div>
);

export default TripTicketTypeSkeleton;
